<template>
  <SoPageWithHeader title="Energy products">
    <EnergyProductList />
  </SoPageWithHeader>
</template>

<script lang="ts">
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import EnergyProductList from "./components/AdminEnergyProductListTable.vue"

  import { defineComponent } from "vue"
  export default defineComponent({
    components: {
      SoPageWithHeader,
      EnergyProductList,
    },
  })
</script>
